import {
  Category,
  IPrevencherCategory,
  ISubCategory,
  ProfileCategories,
  SettingCategories,
  SubCategories,
} from "../types/types";
import venchy from "../images/questionnaire_doctor.png";
import diary from "../images/diary_icon.svg";
import recommendations from "../images/recommendations_icon.svg";
import { tWithKeyAttr as t } from "../i18nHelper";

export const menuTitles: Record<Category, string> = {
  [Category.Day]: "DAY",
  [Category.Treatment]: "TREATMENT",
  [Category.Help]: "HELP",
  [Category.Goals]: "GOALS",
  [Category.Profile]: "PROFILE",
  [Category.Messages]: "MESSAGES",
  [Category.Contacts]: "CONTACTS",
  [Category.Prevencher]: "PREVENCHER",
  [Category.Terms]: "TERMS"
};
export const profileCategories: Record<ProfileCategories, ISubCategory> = {
  [ProfileCategories.Account]: {
    value: ProfileCategories.Account,
    title: t("ACCOUNT"),
  },
  [ProfileCategories.Card]: {
    value: ProfileCategories.Card,
    title: "עדכון פרטי אשראי",
  },
  [ProfileCategories.Invoices]: {
    value: ProfileCategories.Invoices,
    title: "חשבוניות ותשלומים",
  },
  [ProfileCategories.Settings]: {
    value: ProfileCategories.Settings,
    title: "הגדרות",
  },
};

const {
  Treatment,
  Practice,
  Calendar,
  SupportGroup,
  Preferences,
  Docs,
  Account,
  Card,
  Invoices,
  Settings,
  Subscription,
  Support,
  Notifications,
  Faq,
  Coupon,
  Terms,
  Prescriptions,
  Achieved,
  Reports,
  Power,
  Progress,
  Questionnaires,
} = SubCategories;

export const subCategories: Record<SubCategories, ISubCategory> = {
  [Account]: {
    value: Account,
    title: "פרטי חשבון",
  },
  [Card]: {
    value: Card,
    title: "עדכון פרטי אשראי",
  },
  [Invoices]: {
    value: Invoices,
    title: "חשבוניות ותשלומים",
  },
  [Settings]: {
    value: Settings,
    title: "הגדרות",
  },
  [Treatment]: {
    value: Treatment,
    title: "תכנית הטיפול שלי",
  },
  [SupportGroup]: {
    value: SupportGroup,
    title: "קבוצת התמיכה שלי",
  },
  [Practice]: {
    value: Practice,
    title: "התרגילים שלי",
  },
  [Docs]: {
    value: Docs,
    title: "מרשמים שלי",
  },
  [Calendar]: {
    value: Calendar,
    title: "יומן פגישות",
  },
  [Preferences]: {
    value: Preferences,
    title: "המועדפים שלי",
  },
  [Faq]: {
    value: Faq,
    title: "המועדפים שלי",
  },
  [Notifications]: {
    value: Notifications,
    title: "המועדפים שלי",
  },
  [Subscription]: {
    value: Subscription,
    title: "המועדפים שלי",
  },
  [Support]: {
    value: Support,
    title: "המועדפים שלי",
  },
  [Coupon]: {
    value: Coupon,
    title: "המועדפים שלי",
  },
  [Terms]: {
    value: Terms,
    title: "המועדפים שלי",
  },
  [Prescriptions]: {
    value: Prescriptions,
    title: "מרשמים שלי",
  },
  [Achieved]: {
    value: Achieved,
    title: "מה עשיתי החודש",
  },
  [Power]: {
    value: Power,
    title: "דירוג החוסן שלי",
  },
  [Reports]: {
    value: Reports,
    title: "דוחות ההתקדמות שלי",
  },
  [Progress]: {
    value: Progress,
    title: "התקדמות המטרות שלי",
  },
  [Questionnaires]: {
    value: Questionnaires,
    title: "השאלונים שלי",
  },
};


// export const prevencherCategoris: IPrevencherCategory[] = [
//   {
//     value: "intek",
//     img: venchy,
//     title: "אינטק",
//     typeId: 1,
//   },
//   {
//     value: "pniya",
//     img: venchy,
//     title: "פניה",
//     typeId: 9, // ✅ תיקון: פניה = typeId 9
//   },
//   {
//     value: "pgisha",
//     img: venchy,
//     title: "פגישה",
//     typeId: 3,
//   },
//   {
//     value: "yomi",
//     img: diary,
//     title: "יומי",
//     typeId: 4,
//   },
//   {
//     value: "shavui",
//     img: diary,
//     title: "שבועי",
//     typeId: 5,
//   },
//   {
//     value: "hudshi",
//     img: diary,
//     title: "חודשי",
//     typeId: 6,
//   },
//   {
//     value: "default",
//     img: venchy,
//     title: "דיפולטיבי",
//     typeId: 7,
//   },
//   {
//     value: "seker",
//     img: venchy,
//     title: "סקר",
//     typeId: 8,
//   },
//   {
//     value: "link_rashi_zmani",
//     img: venchy,
//     title: "לינק ראשי זמני",
//     typeId: 9,
//   },
//   {
//     value: "inteik_mekutzar",
//     img: venchy,
//     title: "אינטייק מקוצר",
//     typeId: 10,
//   },
//   {
//     value: "inteik_mukdanim",
//     img: venchy,
//     title: "אינטייק מוקדנים",
//     typeId: 11,
//   },
//   {
//     value: "yoman_prevencher",
//     img: diary,
//     title: "יומן פריוונצ'ר",
//     typeId: 12, // ✅ תיקון: יומן פריוונצ'ר = typeId 12
//   },
//   {
//     value: "makirim_et_prevencher",
//     img: venchy,
//     title: "היכרות עם פריוונצ'ר",
//     typeId: 13, // ✅ תיקון: היכרות עם פריוונצ'ר = typeId 13
//   },
//   {
//     value: "help", 
//     img: venchy,  
//     title: "קבלת עזרה",
//     typeId: 2, // ✅ תיקון: help = typeId 2
//   },
// ];

export const prevencherCategoris: IPrevencherCategory[] = [
  {
    value: "help", 
    img: venchy,  
    title: "TITLE_GETTING_HELP",
    typeId: 2,  
  },
  {
    value: "chat",
    img: venchy,
    title: "TITLE_CONVERSATION_WITH_VENCHI",
    typeId: 9, // ✅ שיחה רגילה
  },
  { 
    value: "diary", 
    img: diary, 
    title: "TITLE_PREVENCHER_DIARY", 
    typeId: 12 // ✅ יומן פרוונצר
  },
  {
    value: "knowVenture",
    img: venchy,
    title: "TITLE_GETTING_TO_KNOW_VENCHI",
    typeId: 13, // ✅ היכרות עם פרוונצר
  },
  
  // {
  //   value: "recommendations",
  //   img: recommendations,
  //   title: "TITLE_VENCHI_RECOMMENDATIONS",
  //   disabled: true,
  // },
];

export const settingCategories: ISubCategory[] = [
  {
    value: SettingCategories.Subscription,
    title: "TITLE_SUBSCRIPTION_PLAN",
    disabled: true,
  },
  {
    value: SettingCategories.Support,
    title: "TITLE_TECH_SUPPORT",
  },
  {
    value: SettingCategories.Notifications,
    title: "TITLE_UPDATES_AND_ALERTS",
    disabled: true,
  },
  {
    value: SettingCategories.Faq,
    title: "TITLE_FAQ",
    disabled: false,
  },
  {
    value: SettingCategories.Coupon,
    title: "TITLE_COUPON_CODE",
    disabled: true,
  },
  {
    value: SettingCategories.Terms,
    title: "TITLE_TERMS_AND_PRIVACY",
  },
];

export interface IContactUsTheme {
  title: string;
  text: string;
}
export const reportsCategories: ISubCategory[] = [
  {
    value: "period",
    title: "דו''ח תקופתי",
  },
  {
    value: "summary",
    title: "סיכומי פגישות",
  },
];
